import "../sass/insightsFilter.scss";

document.addEventListener( 'DOMContentLoaded', function() {
    if(document.querySelector(".insight-filter")) {
        let formats = document.getElementById('formats');
        let subjects = document.getElementById('subjects');
        let industries = document.getElementById('industries');
        let formatsOptions = formats.querySelectorAll('.option');
    
        formats.addEventListener('change', function(e) {
            let formatsValue = formats.value;
            formatsOptions.forEach(formatsOption => {
                if(formatsOption.getAttribute('value') === formatsValue) {
                    let formatsOptionUrl = formatsOption.getAttribute('data-url');
                    window.location.href = formatsOptionUrl;     
                }
            });  
        });
    
        // SUBJECTS FILTER
        subjects.addEventListener('change', function() {
            document.querySelector('.insight-filter').submit();
        });
    
        // INDUSTRIES FILTER
        industries.addEventListener('change', function() {
            document.querySelector('.insight-filter').submit();
        });
    }
} );